var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-earning-rules",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: {
          title: _vm.$t("lang.earnRule.earningRules"),
          "left-arrow": "",
        },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow02.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "main" },
        _vm._l(_vm.list, function (item, index) {
          return _c("div", { key: index }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
            _c("div", { staticClass: "con" }, [_vm._v(_vm._s(item.con))]),
            _c("table", { staticClass: "table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("lang.earnRule.hungUpBy")))]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("lang.earnRule.callDuration"))),
                  ]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("lang.earnRule.settlementRatio"))),
                  ]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(item.tableTdList, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(item.td1))]),
                    _c("td", [_vm._v(_vm._s(item.td2))]),
                    _c("td", [_vm._v(_vm._s(item.td3))]),
                  ])
                }),
                0
              ),
            ]),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }